import {
  NewOrderImpressionsMode,
  NewOrderType,
  OrderInfosKeys,
  TNewOrderCountry,
} from "@/entities/new-order";
import {
  TBaseKeyValue,
  TViewsKeyValue,
} from "@/entities/new-order/types/new-order-keywords.type";
import { calcImpressions } from "@/features/new-order/country-item/lib";
import { ICampaignInfo } from "@/Models/ApiModels";
import { TImpressionsInfo } from "@/Pages/CreateCampaignPage/Models/CountryModel";
import { getDatesBetween } from "@/shared/helpers";
import { DATE_FORMAT } from "@/Utils/DateUtils";
import dayjs from "dayjs";
import { getCountriesOfKeywords } from "./get-countries-of-keywords";

export function getParsedDuplicateCountries(
  order: ICampaignInfo,
  dateStart: string,
  dateStop: string,
): TNewOrderCountry[] {
  // Получаем список уникальных стран из ключевых слов
  const countriesList = getCountriesOfKeywords(order.keywords);

  // Получаем информацию о показах по странам
  const impressionsInfo = order.infos.find(
    (info) => info.info_key === OrderInfosKeys.impressions_additional_info,
  )?.info_data as TImpressionsInfo | undefined;

  // Массив всех дат в выбранном диапазоне
  const datesList = getDatesBetween(dateStart, dateStop);
  const firstDate = dayjs(dateStart).format(DATE_FORMAT);

  // Для оптимизации: группируем ключевые слова по стране и сразу фильтруем по последней дате заказа
  const keywordsByCountryLastDate = new Map<string, typeof order.keywords>();

  countriesList.forEach((country) => {
    keywordsByCountryLastDate.set(
      country,
      order.keywords.filter(
        (kw) => kw.country === country && kw.date === order.date_stop,
      ),
    );
  });

  // Собираем итоговый массив по странам
  return countriesList.map((country) => {
    const countryImpressionsType = impressionsInfo?.[country]?.type;
    const impressionsKeysValues = impressionsInfo?.[country]?.keys || {};
    const countryKeywordsLastDate =
      keywordsByCountryLastDate.get(country) || [];

    // Создаём объект страны с нужными полями
    const newCountry: TNewOrderCountry = {
      geo: country,
      keywords: {},
      ...(countryImpressionsType
        ? { impressions: { type: countryImpressionsType } }
        : {}),
    };

    // Сразу создаём keywords[date] для каждой даты
    for (const date of datesList) {
      newCountry.keywords[date] =
        order.type === NewOrderType.install_with_views
          ? ({} as TViewsKeyValue)
          : ({} as TBaseKeyValue);
    }

    // Заполняем keywords по датам и ключевым словам
    for (const keyword of countryKeywordsLastDate) {
      const key = keyword.keyword;

      for (const date of datesList) {
        if (order.type === NewOrderType.install_with_views) {
          const kwords = newCountry.keywords[date] as TViewsKeyValue;

          // На первую дату выставляем installs = value, на остальные = 0
          kwords[key] = {
            installs: date === firstDate ? keyword.value : 0,
            views: 0,
            CR: 100,
          };

          // Импрессионная логика
          if (
            countryImpressionsType === NewOrderImpressionsMode.CR &&
            impressionsKeysValues[key] !== undefined
          ) {
            kwords[key].CR = impressionsKeysValues[key];
            kwords[key].views = kwords[key].installs
              ? calcImpressions(
                  kwords[key].installs,
                  impressionsKeysValues[key],
                )
              : 0;
          } else if (
            countryImpressionsType === NewOrderImpressionsMode.Impressions &&
            impressionsKeysValues[key] !== undefined
          ) {
            kwords[key].views = impressionsKeysValues[key];
          }
        } else {
          const kwords = newCountry.keywords[date] as TBaseKeyValue;
          kwords[key] = date === firstDate ? keyword.value : 0;
        }
      }
    }

    console.log(newCountry);
    return newCountry;
  });
}
